import dayjs from 'dayjs';
dayjs().locale('en').format() // use loaded locale locally
